import Vue from 'vue';

export default {
  getNotifications() {
    return Vue.prototype.axios
      .get('getNotifications', {
        params: {
          orderId: Vue.prototype.$session.get('orderId'),
          dealerId: Vue.prototype.$session.get('dealerId'),
        },
      })
      .then((res) => {
        const response = res.data;
        if (!response.success) throw new Error(`[${response.errorCode}] ${response.errorDescription}`);
        return response;
      })
      .catch((error) => {
        throw error;
      });
  },
};
